"use client";

import { useProvinces } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import type { Kh_Provinces } from "@sisnaker-react-core/karirhub-model-type";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface ProvinceComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
}

export const ProvinceCombobox = ({ initialValue, onChange, onClear, disabled }: ProvinceComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { provinces, isLoading } = useProvinces({ keyword, enabled: !disabled, page: 1, limit: 5 });

  const options: ComboboxOption[] = provinces.map((province: Kh_Provinces) => ({
    value: province.id,
    label: province.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih provinsi"
      searchPlaceholder="Cari provinsi..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
